import React, { useEffect, useState } from "react";
import styles from "./publish-parent-form.module.css";
import { Typography } from "antd";
import { DEFAULT_IMAGE } from "../../constants/common";
import SVGIcon from "../../constants/SVGIcon";
import CustomTextfield from "../../common/input/custom-textfield/custom-textfield";
import StatusChip from "../../components/status-chip/status-chip";
import CustomButton from "../../common/custom-button/custom-button";
import { getAllInstitutions } from "../../services/parent_form";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
// Get base url
const baseUrl = window.location.origin;

const PublishParentForm = () => {
  const [activeInstitutionId, setActiveInstitutionId] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [loading, setLoading] = useState(false);
  const [institutionList, setInstitutionList] = useState([]);
  const user = useSelector((state) => state.user?.user);

  const generateLink = (institutionId) => {
    setActiveInstitutionId(institutionId);
  };

  const handleCopyLink = (parentLink) => {
    navigator.clipboard
      .writeText(parentLink)
      .then(() => {
        toast.success("Link copied to clipboard!");
      })
      .catch(() => {
        toast.error("Failed to copy link.");
      });
  };

  useEffect(() => {
    const timeOut = setTimeout(() => {
      setPageNo(1);
      fetchAllInstitutions();
    }, 500);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  const fetchAllInstitutions = async (
    tempPage = pageNo,
    tempPageSize = pageSize
  ) => {
    try {
      setLoading(true);
      let payload = {
        page: tempPage,
        pageSize: tempPageSize,
      };
      if (user?.role !== "SUPER-ADMIN") {
        payload = {
          institution_id: user?.institution?.id,
        };
      }

      const response = await getAllInstitutions(payload);
      if (response?.data) {
        const data = response?.data?.data?.schools;
        setInstitutionList(data);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className={styles.headerContainer}>
        <Typography className={styles.title}>Parent Form</Typography>
        <div className={styles.button_view}></div>
      </div>
      <div>
        {institutionList.map((institution) => {
          const isActive = institution.id === activeInstitutionId;
           const parentLinkWithId = `${baseUrl}/parent-form-admin/${institution.id}`;

          return (
            <div className={styles.main_view} key={institution.id}>
              <div className={styles.card_view}>
                <img
                  src={institution.institution_logo || DEFAULT_IMAGE}
                  alt="User Profile"
                  height={80}
                  width={80}
                  style={{ borderRadius: "50%", objectFit: "cover" }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = DEFAULT_IMAGE;
                  }}
                />
                <div className={styles.view_name_and_id}>
                  <div className={styles.name_status}>
                    <Typography className={styles.school_name}>
                      {institution.institution_name}
                    </Typography>
                    <StatusChip
                      className={styles.school_name}
                      status={"active"}
                    />
                  </div>
                  <Typography className={styles.school_id}>
                    {`ID: ${institution?.registration_number ? institution?.registration_number : "NA"}`}
                  </Typography>
                </div>

                <div className={styles.button_view}>
                  <CustomButton
                    className={styles.link_button}
                    title={"Generate Link"}
                    onClick={() => generateLink(institution.id)}
                    icon={
                      <SVGIcon
                        name={"link-icon"}
                        width={"22"}
                        height={"11"}
                        className="anticon"
                        stroke={"none"}
                      />
                    }
                  />
                </div>
              </div>
              <div className={styles.middle_line}></div>
              <div className={styles.card_view}>
                <div style={{ width: "100%" }}>
                  <CustomTextfield
                    id={`parent-form-link-${institution._id}`}
                    type="text"
                    className={styles.inputField}
                    value={isActive ? parentLinkWithId : ""}
                    readOnly
                    placeholder="No Link have been generated"
                  />
                </div>
                <div className={styles.button_view}>
                  <CustomButton
                    className={styles.link_button}
                    disabled={!isActive}
                    title={"Copy Link"}
                    onClick={() => handleCopyLink(parentLinkWithId)}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PublishParentForm;
